import React from 'react'
import './TarifHosting.scss'

/*
  Таблица тарифов хостинга. Единицы вынесены в заголовки, в ячейках —
  только числа: так колонки выравниваются по разряду и читаются глазом.
*/
const TarifHosting = ({ data }) => {
  return (
    <div className="tarifsHosting_contetnt">
      <div className="tarifsHosting_title">
        <h1>Тарифы  Хостинг</h1>
        <p>Хостинг - это услуга предоставления пространства на сервере, которая позволяет разместить ваш веб-сайт и обеспечить его доступность в Интернете 24/7.</p>
      </div>
      <div className="tarifsHosting_block">
        <table>
          <thead>
            <tr>
              <th scope="col">Тариф</th>
              <th scope="col">Объём, МБ</th>
              <th scope="col">Цена, TJS/мес</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((e) => (
              <tr key={e.tarifName}>
                <th scope="row">{e.tarifName}</th>
                <td>{e.size}</td>
                <td>{e.price}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TarifHosting
